const PrimaryPlanFactory = function ($resource, $window) {
    const isLocal = $window.location.hostname === "localhost";
    const useMocks = $window.location.hash.split("?")[1] === "useMocks=true";
    const baseUrl = isLocal && useMocks ? $window.location.origin : __baseApiUrl__;
    const primaryPlanApi =
        isLocal && useMocks
            ? "/participant/accounts/assets/data/get-plan-mocks.json"
            : "/participant-web-services/rest/accounts/primaryPlan";

    return $resource(
        baseUrl + primaryPlanApi,
        {},
        {
            query: {
                method: "GET",
                isArray: false
            }
        }
    );
};

PrimaryPlanFactory.$inject = ["$resource", "$window"];
export default PrimaryPlanFactory;
